module.exports = __webpack_public_path__ + "img/txnComplete2.beac2475.svg";